module.exports = __webpack_public_path__ + "img/hr-stone-path-side.4535bcf8.png";